/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SettingsRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './SettingsRpc';
import * as Queries from './SettingsRpc.dfc.new';
import type { AdditionalContextArgs } from './SettingsRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetUserSettingsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetUserSettingsResponseType>,
    References.GetUserSettingsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getUserSettings', References.GetUserSettingsResponseType>
        : References.GetUserSettingsResponseType)
    | undefined;
};

export function useGetUserSettingsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetUserSettingsResponseType>,
    References.GetUserSettingsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserSettingsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_USER_SETTINGS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getUserSettings: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetUserSettingsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetUserSettingsQueryReturn<T>;
}

type UseGetUserSettingsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetUserSettingsResponseType>,
    References.GetUserSettingsRequestType,
    T extends true
      ? Record<'getUserSettings', References.GetUserSettingsResponseType>
      : References.GetUserSettingsResponseType
  >;

export function useGetUserSettingsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetUserSettingsResponseType>,
    References.GetUserSettingsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserSettingsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_USER_SETTINGS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getUserSettings: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetUserSettingsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetUserSettingsLazyQueryReturn<T>;
}

type UseGetUserSettingsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetUserSettingsResponseType>,
    References.GetUserSettingsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getUserSettings', References.GetUserSettingsResponseType>
    : References.GetUserSettingsResponseType;
};

export function useGetUserSettingsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetUserSettingsResponseType>,
    References.GetUserSettingsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserSettingsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_USER_SETTINGS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getUserSettings: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetUserSettingsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetUserSettingsSuspenseQueryReturn<T>;
}

type UseUpdateUserSettingsMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateUserSettingsResponseType>,
    References.UpdateUserSettingsRequestType,
    T extends true
      ? Record<'updateUserSettings', References.UpdateUserSettingsResponseType>
      : References.UpdateUserSettingsResponseType
  >;

export function useUpdateUserSettingsMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateUserSettingsResponseType>,
    References.UpdateUserSettingsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateUserSettingsMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_USER_SETTINGS_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateUserSettings: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateUserSettingsMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateUserSettingsMutationReturn<T>;
}

type UseUploadProfilePhotoMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UploadProfilePhotoResponseType>,
    References.UploadProfilePhotoRequestType,
    T extends true
      ? Record<'uploadProfilePhoto', References.UploadProfilePhotoResponseType>
      : References.UploadProfilePhotoResponseType
  >;

export function useUploadProfilePhotoMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UploadProfilePhotoResponseType>,
    References.UploadProfilePhotoRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUploadProfilePhotoMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPLOAD_PROFILE_PHOTO_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            uploadProfilePhoto: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUploadProfilePhotoMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUploadProfilePhotoMutationReturn<T>;
}

type UseChangePasswordMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.ChangePasswordResponseType>,
  References.ChangePasswordRequestType,
  T extends true
    ? Record<'changePassword', References.ChangePasswordResponseType>
    : References.ChangePasswordResponseType
>;

export function useChangePasswordMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.ChangePasswordResponseType>,
    References.ChangePasswordRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseChangePasswordMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CHANGE_PASSWORD_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            changePassword: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseChangePasswordMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseChangePasswordMutationReturn<T>;
}

type UseGetPasswordStatusQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetPasswordStatusResponseType>,
    References.GetPasswordStatusRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getPasswordStatus', References.GetPasswordStatusResponseType>
        : References.GetPasswordStatusResponseType)
    | undefined;
};

export function useGetPasswordStatusQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetPasswordStatusResponseType>,
    References.GetPasswordStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPasswordStatusQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_PASSWORD_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPasswordStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetPasswordStatusQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetPasswordStatusQueryReturn<T>;
}

type UseGetPasswordStatusLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetPasswordStatusResponseType>,
    References.GetPasswordStatusRequestType,
    T extends true
      ? Record<'getPasswordStatus', References.GetPasswordStatusResponseType>
      : References.GetPasswordStatusResponseType
  >;

export function useGetPasswordStatusLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetPasswordStatusResponseType>,
    References.GetPasswordStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPasswordStatusLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_PASSWORD_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPasswordStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetPasswordStatusLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetPasswordStatusLazyQueryReturn<T>;
}

type UseGetPasswordStatusSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetPasswordStatusResponseType>,
    References.GetPasswordStatusRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getPasswordStatus', References.GetPasswordStatusResponseType>
    : References.GetPasswordStatusResponseType;
};

export function useGetPasswordStatusSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetPasswordStatusResponseType>,
    References.GetPasswordStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPasswordStatusSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_PASSWORD_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getPasswordStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetPasswordStatusSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetPasswordStatusSuspenseQueryReturn<T>;
}

type UseCreateOrUpdatePasswordMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.CreateOrUpdatePasswordResponseType>,
    References.CreateOrUpdatePasswordRequestType,
    T extends true
      ? Record<
          'createOrUpdatePassword',
          References.CreateOrUpdatePasswordResponseType
        >
      : References.CreateOrUpdatePasswordResponseType
  >;

export function useCreateOrUpdatePasswordMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.CreateOrUpdatePasswordResponseType>,
    References.CreateOrUpdatePasswordRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCreateOrUpdatePasswordMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CREATE_OR_UPDATE_PASSWORD_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            createOrUpdatePassword: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCreateOrUpdatePasswordMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCreateOrUpdatePasswordMutationReturn<T>;
}
